import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  alertRulesSearchWrapper: {
    padding: '1.5rem 1.5rem 1rem 1.5rem'
  },
  alertRulesResizablePanelWrapper: {
    borderRadius: 0,
    height: '100%'
  },
  alertRulesPage: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  }
}));

export default useStyles;
